require('./clients-list.scss')

module.exports = {
  template: require('./clients-list.pug')()
  controller: require('./clients-list.ctrl')
  bindings:
    query: '<',
    clients: '<',
    total: '<',
    onRefresh: '&'
}
